import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import ApplicationAPI from './api'

export default class Application extends Model {
  static api = ApplicationAPI.create(Application)
  static readOnlyFields = [
    'id',
    'isEvaluatedByUser',
    'hasCommitmentsByUser',
    'currentEvaluations',
    'evaluatorsRef',
    'organization',
    'percentComplete'
  ]

  constructor({
    id = null,
    name = '',
    cohort = null,
    organization = {},
    submitter = {},
    evaluators = [],
    evaluatorsRef = [],
    evaluations = [],
    evaluationsRef = [],
    isEvaluatedByUser = false,
    hasCommitmentsByUser = false,
    questionOrganizationType = '',
    questionOrganizationWebsite = '',
    questionTellUsAboutYourOrganization = '',
    questionAboutProposalAuthor = '',
    questionWhichTypeOfFunding = '',
    questionTellUsAboutProposal = '',
    questionWhereElseHaveYouSubmitted = '',
    questionWhyRejected = '',
    questionAdditionalComments = '',
    questionChangesToApproach = '',
    questionKujalinkProfile = '',
    organizationSubmittedTo = '',
    proposalName = '',
    organizationName = '',
    projectName = '',
    sortName = '',
    proposal = '',
    proposalLink = '',
    report,
    reportRef,
    percentComplete = '',
  } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
      cohort,
      organization,
      submitter,
      evaluators,
      evaluatorsRef,
      evaluations,
      evaluationsRef,
      isEvaluatedByUser,
      hasCommitmentsByUser,
      questionOrganizationType,
      questionOrganizationWebsite,
      questionTellUsAboutYourOrganization,
      questionAboutProposalAuthor,
      questionWhichTypeOfFunding,
      questionTellUsAboutProposal,
      questionWhereElseHaveYouSubmitted,
      questionWhyRejected,
      questionAdditionalComments,
      questionChangesToApproach,
      questionKujalinkProfile,
      organizationSubmittedTo,
      proposalName,
      organizationName,
      projectName,
      sortName,
      proposal,
      proposalLink,
      report,
      reportRef,
      percentComplete,
    })
  }

  static create(opts = {}) {
    return new Application(opts)
  }

  static fromAPI(json = {}) {
    return new Application(snakeToCamel(json))
  }

  copy() {
    return new Application(this)
  }
}
